import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../ui/table';
import { cn } from '../../lib/utils';

export function DataTable({ columns, data, onRowClick, emptyMessage = 'Keine Daten vorhanden', className }) {
    return (
        <div className={cn('rounded-lg border bg-white overflow-hidden', className)}>
            <Table>
                <TableHeader>
                    <TableRow>
                        {columns.map((column, index) => (
                            <TableHead
                                key={index}
                                className="h-10 px-4 text-left align-middle font-medium text-muted-foreground uppercase text-xs tracking-wider border-b bg-muted/30"
                            >
                                {column.header}
                            </TableHead>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={columns.length} className="h-24 text-center text-muted-foreground">
                                {emptyMessage}
                            </TableCell>
                        </TableRow>
                    ) : (
                        data.map((row, rowIndex) => (
                            <TableRow
                                key={row.id || rowIndex}
                                className={cn(
                                    'border-b transition-colors hover:bg-muted/50',
                                    onRowClick && 'cursor-pointer'
                                )}
                                onClick={() => onRowClick?.(row)}
                                data-testid={`table-row-${row.id || rowIndex}`}
                            >
                                {columns.map((column, colIndex) => (
                                    <TableCell key={colIndex} className="px-4 py-3">
                                        {column.cell ? column.cell(row) : row[column.accessorKey]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </div>
    );
}
